import io from "socket.io-client"
import React, { Component } from "react";
import api_fetch from "../../../api.js";
// import UAParser from "ua-parser-js";
import ActivityStopMotion from "./ActivityStopMotion.jsx";
function format_time(input, language){
  return new Date(input).toLocaleTimeString(language)
}
let static_root = window.location.origin + "/vmserver/raw_activities/";

function format_date(input, language){
  let now = new Date()
  let date = new Date(input);
  
  // let opts = {hour:"numeric", minute: "numeric", second:"numeric"};
  
  // let time_str = date.toLocaleTimeString();
  let date_str = "";
  // if from 2 or more days ago
  let delta = now - date;
  if (delta < 0){
    delta = 0;
  }
  
  if (delta > 1000*(86400 + now.getHours()*3600 + now.getMinutes()*60)){
    let opts = {weekday:"short",day:"numeric", };
  
    // if(now.getMonth() != date.getMonth()){
    opts = {...opts, month: "short"}
    // }
  
    if(now.getFullYear() != date.getFullYear()){
      opts = {...opts, year: "numeric", month: "short"};
    }
    date_str =  date.toLocaleDateString(language, opts);
  }
  else{
    if(now.getDate() != date.getDate()){
      if (language == "es"){
        date_str = "Ayer";
      }
      else{

        date_str = "Yesterday";
      }

    }
    else if(delta < 1000*3600){
      date_str = format_interval(delta/1000, language)
    }
    else{
      if (language == "es"){
        date_str = "";
      }
      else{
        date_str = "";

      }
    }
    
  }

  return date_str;

}
// 20210930
// 
// navigator.language.startsWith("es")

function format_interval(seconds, language){
  if (seconds < 60){
    if (language == "es"){
      return `Hace ${seconds}s.`
    }
    return `${seconds}s. ago`
  }

  if (seconds < 3600){
    let minutes = Math.round(seconds/60);
    let minutes_string = format_minutes(minutes, language)
    if (language == "es"){    
      return `Hace ${minutes}m.`
    }
    return `${minutes}m. ago`
  }
  let hours = parseInt(seconds/3600);
  let minutes = Math.round((seconds %3600)/60);

  if (language == "es"){    
    return `Hace ${hours}h ${minutes}m`
  }
  return `${hours}h ${minutes}m ago`
}

function format_minutes(minutes, language){
  if(minutes == 1){
    if (language == "es"){
      return "min."
    }
    return "min."

  }
  if (language == "es"){
    return "mins."
  }
  return "mins."

}
function insertActivity(activities, epochs, activity){
  const MAX_ACTIVITIES = 300;


  if(epochs.length>=MAX_ACTIVITIES){
    activities.sort(compare_activities);
    epochs.sort(compare_epochs);
  
    epochs.pop();
    activities.pop();
  }
  epochs.push(activity.activity_epoch);
  activities.push(activity);
  
  activities.sort(compare_activities);
  epochs.sort(compare_epochs);

}

function compare_activities( a, b ) {
  if ( parseInt(a.activity_epoch) < parseInt(b.activity_epoch) ){
    return 1;
  }
  if ( parseInt(a.activity_epoch) > parseInt(b.activity_epoch) ){
    return -1;
  }
  return 0;
}


function compare_epochs( a, b ) {
  if ( parseInt(a) < parseInt(b) ){
    return 1;
  }
  if ( parseInt(a) > parseInt(b) ){
    return -1;
  }
  return 0;
}

class ActivitiesWidget extends Component {
  constructor() {
    super();
    this.sio = undefined;
    this.subscribe = this.subscribe.bind(this);
    this.processActivityData = this.processActivityData.bind(this);
    this.selectActivityThumb = this.selectActivityThumb.bind(this);
    this.closeList = this.closeList.bind(this);
    this.closeDetail = this.closeDetail.bind(this);
    // this.stop = this.stop.bind(this);
    // this.reset = this.reset.bind(this);
    // this.mute = this.mute.bind(this);
    // this.unMute = this.unMute.bind(this);
    // this.stateHandler = this.stateHandler.bind(this);
    // this.getVideoId = this.getVideoId.bind(this);
    this.state = {
      view: "compact", //compact, list
      activities: [],
      epochs: [],
      selected_activity: undefined,
      selected_activity_events: undefined,
    
    }
  
  }
  subscribe(){
    this.props.area;
    this.sio.emit("start_listening_to_area", this.props.area, null);
  }
  processActivityData(data){
    let activities = [...this.state.activities];
    let epochs = [...this.state.epochs];
    console.log("got activity data", data);
    for(const activity of data.activities){
      if(! epochs.includes(activity.activity_epoch)){
        // console.log("insert activity ", activities, epochs);
        insertActivity(activities, epochs, activity);
        // console.log("insert activity done ", activities, epochs);
      }
    }
    for(const activity of data.activities){
        //update activity
        for(let i=0; i<activities.length; i ++ ){
          if(activities[i].activity_epoch == activity.activity_epoch){
            console.log("updating activity")
            activities[i] = activity;
            break;
          }

        }
    }
    this.setState({activities, epochs})
    // processActivityData(data){
    //   console.log("processing activity data", data)
    //   // TODO: instead of updating all, it should
    //   // only merge new data.
    //   // it should discard old data to keep size limitted
    //   // activity_widget_area
    //   let area_name = data.activities[0].area;
    //   if (this.state.activity_widget_area !== undefined && area_name == this.state.activity_widget_area){
    //     this.setState({activity_widget_data: data.activities});
    //   }
  
  
    // }    
  }

  selectActivityThumb(index){
    console.log("select thumb", index);
    if(this.state.view == "compact"){
      // event.stopPropagation();
      this.setState({view:"list", selected_activity: undefined});
      return;
    }
    
    if(this.state.selected_activity != index){
      let activity = this.state.activities[index];
      this.setState({selected_activity_events:[]});

      api_fetch(window.location.origin + `/vmserver/events/?area=${activity.area}&activity_epoch=${activity.activity_epoch}&df_query=(activity_label!='noise')`).then(response => {
        if (!response.ok){
          throw new Error(`Response error ${response}` );
        }
        return response.json();
      }).then(data => {
          this.setState({selected_activity_events:data.events}
            
            )
      }).catch(error =>{
        console.error(`Fetching activity events`, error);
      });

    }
    
    this.setState({selected_activity: index});

  }
  closeList(){
    this.setState({view:"compact"})
    // TODO: drive scroll to latest activity
    document.getElementById("activity-widget-list").scrollTo({ top: 0});
  }
  closeDetail(){
    this.setState({view:"list", selected_activity: undefined});
  }
  componentDidMount(){
    this.sio = io();
    this.sio.on("connect", () => {
      console.log("connected to activities vmserver ");
      this.subscribe();
    });
    this.sio.on('area_activities', this.processActivityData);

  }
  componentWillUnmount() {
    // this.stop();
    this.sio.close()

  }
  render() {
    if (this.state.activities === undefined || this.state.activities.length == 0 ){
        return <div></div>

    }
    const activities = this.state.activities.map((activity, index) => {
      return(
          <ActivityThumb
          key={activity.activity_epoch}
          activity={activity}
          clickHandler={() => this.selectActivityThumb(index)}
        />
      )
    });

    let menu = null;
    let detailClassName = undefined;
    let activitiesClassName = "activity-list";
    if(this.state.view == "compact"){
      detailClassName = " activity-widget-container-height-compact";
      activitiesClassName += " overflow-y-hidden";
    }
    if(this.state.view == "list"){
      detailClassName = " activity-widget-container-height-list";
      activitiesClassName += " overflow-y-scroll";
      menu = (
        <div className="flex-row">
          <button onClick={this.closeList}
            className="button-container activity-list-close-button fa fa-times" />

        </div>
      )
    }
    let detailView = undefined;
    if(this.state.view == "list" && this.state.selected_activity !== undefined){
      detailView = (
        <ActivityDetail 
          closeDetail={this.closeDetail} 
          activity={this.state.activities[this.state.selected_activity]}
          key={this.state.activities[this.state.selected_activity].activity_time}
          events={this.state.selected_activity_events}
          />
      );
    }

    
    return (
      <div className="activity-widget-container" > 
          
          <div className={"flex-row " + detailClassName}>
            <div className="flex-column">
              {menu}
              <div id="activity-widget-list" className={activitiesClassName}>
                
                {activities} 
              </div>

            </div>
            {detailView}
          </div>
      </div>
      )


  }
}
function format_label(label){
  let classes = "activity-icon fa ";
  if (label=="vehicle"){
    classes += " fa-car-side"
  }
  else if (label=="dog"){
    classes += " fa-dog"
  }  
  else if (label=="motorbike"){
    classes += " fa-motorcycle"
  }
  else if (label=="cyclist"){
    classes += " fa-bicycle"
  }
  else if (label=="person"){
    classes += " fa-walking"
  }
  else if (label=="noise"){
    classes += " fa-minus"
  }
  else if (label=="gate"){
    classes += " fa-torii-gate"
  }

  else{
    classes += " fa-question"
  }
  return classes


}
function ActivityThumb(props){
  // TODO: use relative URL (via nginx proxying)
  let language = navigator.language.split("-")[0];
  // let language = "es";
  let static_root = window.location.origin + "/vmserver/raw_activities/";
  // let tmp = <div>{Math.round(100*props.activity.confidence)}%  </div>;
  let class_name = "high-conf";
  if (props.activity.confidence < 0.95){
    class_name = "low-conf";
  }
  if (props.activity.confidence < 0.9){
    class_name = "super-low-conf";
  }

  let conf_label = (
    <div className={'activity-thumb-conf-label ' + class_name + ' flex-row'}>
      <div className={format_label(props.activity.label)} ></div>
      
    </div>
  );
  let plate = undefined
  if (props.activity.plate){
    plate = (
      <div className={'activity-thumb-plate-label flex-row'}> 
       {props.activity.plate} 
      </div>
    );
  }
  let identification = undefined;
  if (plate !== undefined){
    identification = plate;
  }
  else{
    identification=conf_label
  }

  
  return (
    <div className="activity-thumb-container" onClick={props.clickHandler}>
      <div className="flex-row justify-content-space-between position-relative">
        <div className="activity-thumb-time flex-column" >
          <div className="font-size-smaller">{format_date(props.activity.activity_time, language)}</div>
          <div>{format_time(props.activity.activity_time, language)}</div>
        </div>
        {identification}
        <img className="activity-thumb-image" src={static_root + props.activity.top_activity_photos[0]} />

      </div>
    </div>
  )

}


class ActivityDetail extends Component {
  constructor() {
    super();
  
  }  
  componentDidMount(){
  }  
  render(){
    let props = this.props;
    let language = navigator.language.split("-")[0];
    


    let low_conf = false;
    if (props.activity.confidence < 0.97){
      low_conf = true;
    }
    let activityStopMotion = undefined; //pass props.events
    if (props.events !== undefined){
      activityStopMotion = <ActivityStopMotion events={props.events} top_event_index={props.activity.top_event_index} />;
    }

    let plate_image = undefined;
    if (props.activity.plate_image_path){
      plate_image = (
        <div className="activity-detail-header-plate-image-container" > 
          <img className="activity-detail-header-plate-image" src={static_root + props.activity.plate_image_path}></img>
        </div>
      );
    }
    return(
      <div className=" activity-detail-container flex-column ">
        <div className="flex-row justify-content-space-between">
          <div className="flex-column justify-content-flex-end">
            <div className="activity-detail-header flex-column">
              <div className="flex-row">
                <div>{format_time(props.activity.activity_time, language)}</div>
                <div className="activity-detail-header-evinfo">({Math.round(props.activity.duration)}s, {props.activity.nevents}ev)</div>
                <div className={format_label(props.activity.label)} ></div>
              </div>
              {/* <div className="flex-grow-1"></div> */}
              {/* <div> {low_conf ? '? ' + Math.round(props.activity.confidence *100,2) + '%' : ''}</div> */}
              <div className="flex-row activity-detail-header-plate">
                { plate_image }
                <div className="activity-detail-header-plate-value" > { props.activity.plate } </div>

              </div>
              
            </div>
          </div>
          <button onClick={props.closeDetail} className="button-container activity-detail-close-button fa fa-angle-double-left" /> 
        </div>
        <div className="ac-sm-container" id="ac-sm-container">
          
          {activityStopMotion}
  
        </div>
  
        
  
      </div>
  
    )
  }
}


export default ActivitiesWidget;